// Editar o valor de uma parte da divisão (dono, 24/09/2026): "dividi R$ 22 em
// 4, o segundo quer pagar R$ 10" — a parte vira R$ 10 e as que ainda faltam
// dividem o resto. As partes já pagas não mudam. A soma das partes continua
// IGUAL ao total da divisão, em centavos: é o que fecha os produtos sem sobra.
import { brl } from "./formato";

const centavos = (v) => Math.round((Number(v) || 0) * 100);
const reais = (c) => Math.round(c) / 100;

// Divide `totalC` centavos em `n` partes iguais, sobra na última
function repartir(totalC, n) {
  const base = Math.floor(totalC / n);
  return Array.from({ length: n }, (_, i) => (i === n - 1 ? totalC - base * (n - 1) : base));
}

/**
 * Parte editada à mão fica "fixa" (`divisao.fixas[i]`): editar outra parte
 * não mexe nela. As não fixas que faltam dividem o resto em partes iguais;
 * parte que zera sai; se todas as que faltam são fixas e sobra valor, entra
 * uma parte nova com a sobra. Devolve `{ divisao }` ou `{ erro }`.
 */
export function editarParte(divisao, indice, valor) {
  const { pagas, valores } = divisao;
  if (indice < pagas || indice >= valores.length) return { erro: "Essa parte já foi paga." };
  const valorC = centavos(valor);
  if (!(valorC > 0)) return { erro: "Informe um valor maior que zero." };

  const fixa = (i) => i === indice || !!divisao.fixas?.[i];
  const pagoC = valores.slice(0, pagas).reduce((s, v) => s + centavos(v), 0);
  const faltaC = centavos(divisao.liquido) - pagoC;
  let outrasFixasC = 0;
  for (let i = pagas; i < valores.length; i++) if (i !== indice && fixa(i)) outrasFixasC += centavos(valores[i]);
  const maximoC = faltaC - outrasFixasC;
  if (valorC > maximoC) return { erro: `Essa parte pode ser de no máximo ${brl(reais(maximoC))}.`, maximo: reais(maximoC) };

  const partes = valores.map((v, i) => ({ c: i === indice ? valorC : centavos(v), fixa: i >= pagas && fixa(i), paga: i < pagas }));
  const livres = partes.map((p, i) => i).filter((i) => !partes[i].paga && !partes[i].fixa);
  const sobraC = maximoC - valorC;
  if (livres.length) repartir(sobraC, livres.length).forEach((c, j) => { partes[livres[j]].c = c; });
  else if (sobraC > 0) partes.push({ c: sobraC, fixa: false, paga: false });

  const ficam = partes.filter((p) => p.paga || p.c > 0);
  return {
    divisao: {
      ...divisao,
      valores: ficam.map((p) => reais(p.c)),
      fixas: ficam.map((p) => p.fixa),
      partes: ficam.length,
    },
  };
}

/** Maior valor que a parte `indice` aceita (o que falta menos as outras fixas). */
export function maximoDaParte(divisao, indice) {
  const { pagas, valores } = divisao;
  const pagoC = valores.slice(0, pagas).reduce((s, v) => s + centavos(v), 0);
  let outrasC = 0;
  for (let i = pagas; i < valores.length; i++) if (i !== indice && divisao.fixas?.[i]) outrasC += centavos(valores[i]);
  return reais(centavos(divisao.liquido) - pagoC - outrasC);
}
